// @flow

export const LOAD_ALERTS: 'ALERTS.LOAD_ALERTS' = 'ALERTS.LOAD_ALERTS';
export const SET_ALERT: 'ALERTS.SET_ALERT' = 'ALERTS.SET_ALERT';
export const UNSET_ALERT: 'ALERTS.UNSET_ALERT' = 'ALERTS.UNSET_ALERT';

